import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "../../../shared/components/Breadcrumbs";
import ListView from "../../../shared/components/listview/ListView";
import { HIRE_STATUS } from "../../../shared/constants/Constants";
import DefaultButton from "../../../shared/components/DefaultButton";
import { CREATENEW } from "../../../shared/constants/Constants";
import Modalpopup from "../../../shared/components/Modalpopup";
import { loadHireStatusDataRequest, loadHireStatusDeleteDataRequest } from "../redux/Actions";
import HireStatusAdd from "./HireStatusAdd";
import HireStatusEdit from "./HireStatusEdit";
import DeleteModal from "../../../shared/components/DeleteModal";
import Permissions from "../../../shared/components/Permissions";

const HireStatus = () => {
    let dispatch = useDispatch();
    let navigate = useNavigate();
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    let { hireStatuses, loading } = useSelector((state) => state.hireStatus);
    let [selectedRow, setSelectedRow] = useState({})
    let [shouldReload, setShouldReload] = useState(true)

    useEffect(() => {
        if (shouldReload && !loading) {
            setShouldReload(false)
            dispatch(loadHireStatusDataRequest());
        }
    }, [dispatch, loading, shouldReload]);

    let emp_no = JSON.parse(localStorage.getItem("emp_no"));
    let module_name = "Hire Status";
    let permission = Permissions(emp_no, module_name);

    let actionsPermission = !(permission.write_permission || permission.delete_permission);

    let columns = [
        {
            display_name: "id",
            field: "id",
            type: "number",
            hide: true
        },
        {
            display_name: HIRE_STATUS,
            field: "name",
            type: "text",
        },
        {
            display_name: "Training Days",
            field: "training_days",
            type: "text",
        },
        {
            display_name: "",
            field: 'actions',
            type: 'actions',
            hide: actionsPermission
        }
    ];

    const handleDelete = () => {
        dispatch(loadHireStatusDeleteDataRequest({ id: [selectedRow] }))
        setShouldReload(true);
        setShowDeleteModal(false);
    }

    let [clickEditFunc, setClickEditFunc] = useState(null);
    let [clickDeleteFunc, setClickDeleteFunc] = useState(null);
    useEffect(() => {
        if (permission.write_permission) {
            setClickEditFunc(
                () => (row) => {
                    setSelectedRow(row);
                    setShowEditModal(true);
                })
        }
        if (permission.delete_permission) {
            setClickDeleteFunc(
                () => (id) => {
                    setSelectedRow(id);
                    setShowDeleteModal(true);
                })
        }
    }, [permission])
    return (
        <>
            <Row>
                <Col className="gx-0">
                    <Breadcrumbs
                        children={[
                            { label: HIRE_STATUS },
                        ]}
                    />
                </Col>
                <Col xs="auto" className="gx-0">
                    {permission.create_permission ? (
                            <DefaultButton
                                buttonClass="btn btn-primary default-btn-color"
                                buttonTitle={CREATENEW}
                                actionBlock={() => setShowCreateModal(true)}
                            />
                    ) : ""}
                </Col>
            </Row>
            <Row>
                <Card>
                    <Card.Body>
                        <ListView
                            exportTitle={HIRE_STATUS}
                            columnNames={columns}
                            rowData={hireStatuses}
                            clickEdit={clickEditFunc}
                            clickDelete={clickDeleteFunc}
                        />
                    </Card.Body>
                </Card>
            </Row>
            <Modalpopup
                show={showCreateModal}
                handleClose={() => setShowCreateModal(false)}
                actionTitle={"Create " + HIRE_STATUS}
            >
                <HireStatusAdd
                    handleClose={(reload) => {
                        setShowCreateModal(false);
                        if (reload) {
                            //setShouldReload(reload)
                            dispatch(loadHireStatusDataRequest());
                        }
                    }}
                />
            </Modalpopup>
            <Modalpopup
                show={showEditModal}
                handleClose={() => { setShowEditModal(false) }}
                actionTitle={"Edit " + HIRE_STATUS}
            >
                <HireStatusEdit
                    hireStatus={selectedRow}
                    handleClose={(reload) => {
                        if (reload) {
                            //setShouldReload(reload)
                            dispatch(loadHireStatusDataRequest());
                        }
                        setShowEditModal(false)
                    }}
                />
            </Modalpopup>
            <DeleteModal
                handleClose={() => { setShowDeleteModal(false) }}
                handleDelete={handleDelete}
                show={showDeleteModal}
            >
                <div>
                    Delete {HIRE_STATUS}?
                </div>
            </DeleteModal>
        </>
    );
};

export default HireStatus;
